export const environment = {
  production: true,
  apiUrl: 'https://api.prismcalifornia.org/',
  url: 'https://prismcalifornia.org/home',
  authToken: 'prism-token',
  storageName: " prismprodstorage",
  storageUrl: 'storageUrl',
  encryptionKey: "4a25f88fcac1b07e93a6dba85e3018e7",
  recaptcha: {
    siteKey: '6LcnYXMrAAAAAJry2YzPMnHWcx4eijvTl6FSvK7X',
  },
  gaTrackingId: 'G-S063EBSV4H',
  uploadFileUrl: `https://prismprodstorage.blob.core.windows.net`,
  uploadFileLink: `https://prismprodstorage.blob.core.windows.net/resources/user/Prism-BulkUserUploadTemplate.xlsx`,
  heroVideo: `https://prismprodstorage.blob.core.windows.net/resources/landing/prism-hero-vid.mp4`,
  appinsights: `InstrumentationKey=0db68fa4-7931-4fd7-8ec2-1e3fddd27487;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=e01a0a58-b1a0-43ed-8e8a-d5cef3bb8983`,
  refreshThresholdMinutes: 15, // Adjusted for session monitoring
  courseTimeoutMinutes: 60, // Adjusted for course timeout
  isSiteOffline: false
};
